import { ModuleWithProviders, Provider, Type } from '@angular/core';

import { PresetType } from '../preset-token';
import { providePreset } from './preset';
/**
 * @param {?} moduleClass
 * @param {?} presetType
 * @param {?=} additionalProviders
 * @return {?}
 */
export function providePresetFor(
  moduleClass: Type<any>,
  presetType: Type<PresetType>,
  additionalProviders: Provider[] = [],
): ModuleWithProviders {
  return {
    ngModule: moduleClass,
    providers: [...providePreset(presetType), ...additionalProviders],
  };
}
